import React from 'react';

const OfficesTab = ({ offices, currentUser }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {offices && offices.length > 0 ? (
        offices.map((office) => (
          <div key={office.office_id} className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium text-lg mb-2">{office.name}</h3>
            <div className="text-gray-600">
              <p class="mb-0">{office.address1}</p>
              {office.address2 && <p class="mb-0">{office.address2}</p>}
              {office.address3 && <p class="mb-0">{office.address3}</p>}
              {office.town && <p class="mb-0">{office.town}</p>}
              {office.postcode && <p class="mb-2">{office.postcode}</p>}
              {office.phone_number && (
                <p className="mb-2">
                  <span className="font-medium">Tel:</span> {currentUser ? office.phone_number : "Please sign up to view contact details"}
                </p>
              )}
              {office.email && (
                <p className="mb-0">
                  <span className="font-medium">Email:</span> {currentUser ? office.email : "Please sign up to view contact details"}
                </p>
              )}
            </div>
          </div>
        ))
      ) : (
        <p className="text-gray-500 italic">No office locations available</p>
      )}
    </div>
  );
};

export default OfficesTab; 